var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { findFlagUrlByIso2Code } from './helper';
var CountryFlagIcon = function (_a) {
    var iso2Code = _a.iso2Code, imageProps = _a.imageProps;
    return React.createElement("img", __assign({ height: 16, width: 24 }, imageProps, { src: findFlagUrlByIso2Code(iso2Code) }));
};
export default CountryFlagIcon;
//# sourceMappingURL=CountryFlagIcon.js.map